import ProxyBaseDAO from "./ProxyBaseDAO";
import LojaModel from "../../model/LojaModel";

class ProxyMensagemDAO extends ProxyBaseDAO {
  private static instance: ProxyMensagemDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): ProxyMensagemDAO {
    if (!ProxyMensagemDAO.instance) {
      ProxyMensagemDAO.instance = new ProxyMensagemDAO();
    }
    return ProxyMensagemDAO.instance;
  }

  public async sendMensagem(
    loja: LojaModel,
    assunto: string,
    mensagem: string
  ): Promise<any> {
    return super.post(`${this.endpoint}/Oba/sendEmail`, {
      subject: `[Loja: ${loja.nome}] ${assunto}`,
      message: mensagem,
    });
  }
}

export default ProxyMensagemDAO;
